<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form) => {
        this.searchForm = form;
      }
        ">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="区域" fieldDecoratorId="region_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in areas" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="门店名称" fieldDecoratorId="branch_name">
              <a-input placeholder="请填写" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-divider type="vertical" />
              <a-button type="primary" @click="handleAdd" icon="plus">新建门店</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

    </div>
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="outlets" slot-scope="text, record">
        <a-switch :checked="text" @click="setFeatured(record)" />
      </template>
      <template slot="action" slot-scope="text, record">
        <div class='editable-row-operations'>
          <!-- <a @click="showAdminList(record)">管理账号</a>
          <a-divider type="vertical" /> -->
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="deleteStore(record)">删除</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="'确定' + (record.visible ? '隐藏' : '显示') + '此门店吗？'" @confirm="setBranchVisible(record)"
            okText="是" cancelText="否">
            <a>{{ record.visible ? '隐藏' : '显示' }}</a>
          </a-popconfirm>
        </div>
      </template>
    </s-table>
    <!-- 编辑/新增门店 -->
    <a-modal :title="modal_title" :width="800" v-model="visible" okText='提交' @ok="handleOk" @cancel="handleCancel">
      <a-form :autoFormCreate="(form) => { this.form = form }">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label='门店名称' fieldDecoratorId="name"
          :fieldDecoratorOptions="{
            rules: [{ required: true, message: '请填写门店名称' }],
            initialValue: mdl.name,
          }">
          <a-input placeholder='门店名称' />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属区域" fieldDecoratorId="region_id"
          :fieldDecoratorOptions="{
            rules: [{ required: true, message: '请选择所属区域' }],
            initialValue: mdl.region_id,
          }">
          <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
            <a-select-option v-for="item in areas" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label='负责人' fieldDecoratorId="manager"
          :fieldDecoratorOptions="{
            rules: [{ required: true, message: '请填写负责人' }],
            initialValue: mdl.manager,
          }">
          <a-input placeholder='负责人' />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label='联系方式' fieldDecoratorId="mobile"
          :fieldDecoratorOptions="{
            rules: [{ required: true, message: '请填写负责人联系方式' }],
            initialValue: mdl.mobile,
          }">
          <a-input placeholder='联系方式' />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label='门店地址' fieldDecoratorId="address"
          :fieldDecoratorOptions="{
            rules: [{ required: true, message: '请填写门店地址' }],
            initialValue: mdl.address,
          }">
          <a-input placeholder='门店地址' />
        </a-form-item>
        <a-form-item :labelCol="labelCol" label="轮播图" fieldDecoratorId="branch_banners" :fieldDecoratorOptions="{
          rules: [{
            required: true, message: '请上传轮播图', validator: (rule, value, callback) => {
              value.length > 0 ? callback() : callback('请上传轮播图')
            }
          }],
          initialValue: mdl.branch_banners,
        }">
          <div style="display:flex;flex-wrap: wrap">
            <a-upload name="file" listType="picture-card" class="avatar-uploader" :showUploadList="false"
              action="//upload.qiniup.com" :beforeUpload="beforeCoverUpload" :data="imgForm"
              @change="(info) => handleCoverChange(info)">
              <div>
                <a-icon :type="'plus'" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
            <div v-for="(i, index) in mdl.branch_banners" :key="index" class="img-box">
              <img width="102" height="102" :src="i" />
              <div class="del-img" @click="delImg(index)">
                <a-icon type="close" />
              </div>
            </div>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import { getBranchList, updateBranch, deleteBranch, getBranchIdentify, setVisibleBranch, setOutletsBranch } from '@/api/branch'
import { addAdminUser, updateAdminUser, deleteAdminUser } from '@/api/admin_user'
import { getAreaList } from '@/api/area'
import { getQiniuToken } from "@/api/qiniu";

export default {
  name: 'Branch',
  components: {
    STable
  },
  created() {
    this.getAreaList()
  },
  data() {
    return {
      visible: false,
      adminVisible: false, // 修改添加管理员
      adminListVisible: false, // 管理员列表
      idenVisible: false,//机器编号管理
      selectedBranch: {},
      modal_title: '添加门店',
      branch_id: 0,
      searchForm: null,
      imgForm: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      areas: [],
      userForm: null,
      confirmDirty: false,
      admin: {},
      mdl: {},
      queryParam: {}, // 表头
      adminList: [],
      idenList: [],
      adminColumns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '用户名',
          dataIndex: 'username'
        },
        {
          title: '真实姓名',
          dataIndex: 'real_name'
        },
        {
          title: '手机号',
          dataIndex: 'phone_number'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      // 表头
      columns: [
        {
          title: '门店ID',
          dataIndex: 'id'
        },
        {
          title: '门店名称',
          dataIndex: 'name',
        },
        {
          title: '区域',
          dataIndex: 'region_name',
        },
        {
          title: '负责人',
          dataIndex: 'manager',
        },
        {
          title: '联系方式',
          dataIndex: 'mobile',
        },
        {
          title: '门店地址',
          dataIndex: 'address',
        },
        {
          title: '是否奥莱店',
          dataIndex: 'is_outlets',
          scopedSlots: { customRender: 'outlets' },
        },
        {
          title: '注册时间',
          dataIndex: 'created',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      idenColumns: [
        {
          title: '机器编号',
          dataIndex: 'void',
          scopedSlots: { customRender: 'void' },
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        return getBranchList(Object.assign(params, this.queryParam)).then(res => res)
      },
    }
  },
  methods: {
    setFeatured(record) {
      setOutletsBranch(record.id)
        .then(res => {
          this.$refs.table.refresh()
        })
    },
    delImg(index) {
      this.mdl.branch_banners.splice(index, 1)
    },
    handleCoverChange(info) {
      if (info.file.status === "uploading") {
        // this.loading = true;
      } else if (info.file.status === "done") {
        let key = info.file.response.key;
        let url = `${this.bucketHost}${key}`
        // this.pic_url = `${this.bucketHost}${key}`;
        // this.loading = false;
        this.mdl.branch_banners.push(url)
        this.$forceUpdate()
      } else if (info.file.status === "error") {
        // this.loading = false;
        this.$message.error("上传图片失败，请重试");
      } else if (info.file.status === "removed") {
        console.log("removed");
      }
    },
    beforeCoverUpload() {
      let _this = this;
      return getQiniuToken().then((res) => {
        _this.bucketHost = res.bucket_host;
        _this.imgForm = {
          token: res.qiniu_token,
        };
      });
    },
    setBranchVisible(record) {
      setVisibleBranch(record.id)
        .then(res => {
          this.$refs.table.refresh()
        })
    },
    getAreaList: function () {
      getAreaList().then(res => {
        console.log(res)
        this.areas = res.list
      })
    },
    handleSearch(e) {
      e.preventDefault();
      this.queryParam = {
        region_id: this.searchForm.getFieldValue("region_id"),
        branch_name: this.searchForm.getFieldValue("branch_name")
      };
      this.$refs.table.refresh();
    },
    handleAdd() {
      this.mdl = {}
      this.mdl.branch_banners = []
      this.visible = true
    },
    handleEdit(record) {
      this.modal_title = '修改门店'
      this.mdl = Object.assign({}, record)
      this.mdl.branch_banners = this.mdl.branch_banners.map(item => item.banner)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          values.banner = this.mdl.branch_banners
          updateBranch({ ...values, id: this.mdl.id }).then(res => {
            this.$refs.table.refresh()
            this.$message.success('操作成功')
            this.form.resetFields()
            this.visible = false
          })
        }
      })
    },
    handleCancel() {
      this.form.resetFields()
      this.visible = false
    },
    // eslint-disable-next-line
    deleteStore(row) {
      const _this = this
      this.$confirm({
        title: '警告',
        content: '真的要删除吗?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          deleteBranch(row.id).then(res => {
            _this.$refs.table.refresh()
            _this.$message.success('删除成功')
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    showAdminList(row) {
      this.selectedBranch = row
      this.adminList = row.admin ? row.admin.filter(item => item.deleted == 0) : []
      this.adminListVisible = true
    },
    handleAddUser() {
      this.userForm.validateFields((err, values) => {
        if (!err) {
          if (this.admin.id) {
            updateAdminUser(this.admin.id, values).then(res => {
              if (res.code === 0) {
                this.$refs.table.refresh()
                this.$message.success('修改成功')
                this.userForm.resetFields()
                for (const v of this.adminList) {
                  if (v.id === res.data.id) {
                    const index = this.adminList.indexOf(v)
                    this.adminList.splice(index, 1, res.data)
                    break
                  }
                }
                this.adminVisible = false
              }
            })
          } else {
            this.admin.username = values.username
            this.admin.password = values.password
            this.admin.real_name = values.real_name
            this.admin.phone_number = values.phone_number
            addAdminUser(this.admin).then(res => {
              this.$refs.table.refresh()
              this.$message.success('添加成功')
              this.userForm.resetFields()
              this.adminList.unshift(res.data)
              this.adminVisible = false
            }).catch(() => {
              this.userForm.resetFields()
            })
          }

        }
      })
    },
    cancelAddUser() {
      this.userForm.resetFields()
      this.adminVisible = false
    },
    handleIden() {
      var obj = {
        void: '',
      }
      this.idenList.push(obj)
    },
    handleAddiden() {
      const params = {
        id: this.branch_id,
        number: this.idenList
      }
      getBranchIdentify(params).then(() => {
        this.$message.success('提交成功')
        this.idenList = []
      })
    },
    addUser() {
      this.admin = {
        id: 0,
        username: null,
        real_name: null,
        phone_number: null,
        password: '',
        role: 'guest',
        branch_id: this.selectedBranch.id
      }
      this.adminVisible = true
    },
    editUser(row) {
      this.admin = row
      this.adminVisible = true
    },
    deleteUser(row) {
      deleteAdminUser(row.id).then(() => {
        this.$message.success('删除成功')
        const index = this.adminList.indexOf(row)
        this.adminList.splice(index, 1)
      })
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.userForm
      if (value && value !== form.getFieldValue('password')) {
        callback('两次密码不一致')
      } else {
        callback()
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.userForm
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },
  }
}
</script>
<style scoped lang="less">
.add-btn {
  margin-bottom: 10px;
}

.img-box {
  margin-right: 8px;
  margin-bottom: 8px;
  position: relative;

  .del-img {
    position: absolute;
    top: -10px;
    right: -10px;
    background: rgba(0, 0, 0, .45);
    color: #fff;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    cursor: pointer;
  }
}
</style>
